import appImage from "../../assets/images/box2_img.png";
import Text from "../../components/Text";
import DownloadAppDropDown from "../../components/DownloadAppDropDown";
const DownloadAppSection = () => {
  return (
    <div className="flex justify-center">
      <div className="xs:p-0 sm:px-6 lg:p-0">
        <div className="box-content flex xs:flex-col md:flex-row bg-[#fde1d3] sm:rounded-2xl md:rounded-none">
          <div className="img xs:w-full md:w-5/12 flex justify-center">
            <img
              src={appImage}
              alt=""
              className="rounded-2xl object-cover w-full"
            />
          </div>
          <div className="content xs:w-full md:w-7/12 p-8 m-auto">
            <div className="heading text-base pb-5">
              <Text text={"Do even more with the Gepzo app"} />
            </div>
            <div className="desc text-sm pb-5">
              <Text
                text={
                  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
                }
              />
            </div>
            <div className="buttons flex xs:items-center lg:items-start xs:flex-col lg:flex-row">
              <DownloadAppDropDown />
              <div className="learn-more flex justify-center items-center xs:w-4/6 lg:w-1/2 py-2">
                <a href="" className="flex justify-center items-center">
                  <Text text={"Learn More"} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppSection;
